import axios from "./axiosInstance";

export const getAllUsers = async () => {
  const res = await axios.get(`/users/list`);
  return res.data.data;
};

export const createUser = async (payload) => {
  const res = await axios.post(`/admin/users/create`, payload);
  return res.data.data;
};

export const getUserDetails = async (userId) => {
  const res = await axios.get(`/admin/users/details/${userId}`);
  return res.data.data;
};

export const updateUser = async (userId, payload) => {
  const res = await axios.put(`/admin/users/update/${userId}`, payload);
  return res.data.data;
};

export const deleteUser = async (userId) => {
  const res = await axios.delete(`/admin/users/delete/${userId}`);
  return res.data;
};
